import styled from 'styled-components';
import { TOP_HEADER_HEIGHT } from '../constants.js';
import { unit, pxToRem } from '../../foundation/spacing/utils.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';

var NavigationBar = styled.div.withConfig({
  displayName: "NavigationBar",
  componentId: "sc-twcsae-0"
})(["box-sizing:border-box;display:flex;align-items:center;padding:", " 0;background-color:", ";width:100%;height:", ";position:sticky;top:0;z-index:1;"], unit('lg'), themeGet('colors.gray.0'), pxToRem(TOP_HEADER_HEIGHT));

export { NavigationBar };
